import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useScrollReveal } from "../../../hooks/useScrollReveal";
import { useNavigationContext } from "../../common/navigation/NavigationContext";

export default function WorkflowRefreshESG() {
  const navigate = useNavigate();
  const revealRef = useScrollReveal();
  const { setWorkflowContext } = useNavigationContext();

  // 🎯 Every time this Hub mounts, it becomes the "Return" destination
  useEffect(() => {
    setWorkflowContext("Refresh ESG Taxonomy", "/registered/site-admin/taxonomy-workflow");
  }, [setWorkflowContext]);

  const workflowSteps = [
    {
      title: "Import ESG",
      description: "Upload official EFRAG Excel taxonomy linkbases (Presentation, Calculation, and Definition). This will be used in step 2 to prepare and validate the  input template for a reporting period.",
      icon: "bi-file-earmark-excel-fill",
      actionLabel: "Upload ESG Taxonomy",
      actionTarget: "/registered/upload/monitor",
      active: true 
    },
    {
      title: "Validate and Prepare",
      description: "Choose the file uploaded in setp 1 to use to build the declaration template for an ESG reporting period. Declarations templates are used to  build the input templates users need to input their ESG reportng values.After this step you can map each of the ESG Pillars and mneasure combinations to 'Declaration templates'.",
      icon: "bi-diagram-3-fill",
      actionLabel: "Process Data",
      // 🎯 UPDATED: Points to your new XLS to Schema component
      actionTarget: "/registered/site-admin/workflow_hub",
      active: true // 🎯 ENABLED
    },
    {
      title: "Reporting Templates",
      description: "Curate specific disclosure scopes using the generated taxonomy logic.",
      icon: "bi-collection-fill",
      actionLabel: "Manage Templates",
      actionTarget: "#",
      active: false
    },
    {
      title: "Evaluation & Determination",
      description: "Capture inputs against templates to determine compliance and materiality scores.",
      icon: "bi-check-circle-fill",
      actionLabel: "Open Evaluator",
      actionTarget: "#",
      active: false
    }
  ];

  return (
    <div className="page-main" data-scroll-container>
      <div className="page-main-inner">
        
        {/* HERO SECTION */}
        <section ref={revealRef} className="page-hero reveal-section" data-scroll>
          <h1 className="page-hero__title">Refresh ESG Taxonomy</h1>
          <p className="page-hero__lead">
            Strategic Workflow: Transforming EFRAG Source into Reporting Intelligence
          </p>
        </section>

        {/* WORKFLOW STEPS SECTION */}
        <section className="page-section px-4">
          <div className="row g-4 mb-5">
            {workflowSteps.map((step, index) => (
              <div key={index} className="col-12 col-md-6 col-lg-3">
                <div className={`card h-100 border-0 shadow-sm bg-white ${!step.active ? 'opacity-75' : ''}`}>
                  <div className="card-body p-4 d-flex flex-column text-center">
                    <div className="d-inline-flex align-items-center justify-content-center bg-primary bg-opacity-10 text-primary rounded-circle mb-3 p-4 mx-auto">
                      <i className={`bi ${step.icon} fs-2`}></i>
                    </div>
                    <h5 className="fw-bold mb-2 small text-uppercase text-secondary">Step {index + 1}</h5>
                    <h6 className="fw-bold mb-3">{step.title}</h6>
                    <p className="small text-muted mb-4 flex-grow-1">{step.description}</p>
                    
                    <button 
                      type="button" 
                      className={`btn w-100 fw-bold ${step.active ? 'btn-primary shadow-sm' : 'btn-outline-secondary disabled'}`}
                      onClick={() => step.active && navigate(step.actionTarget)}
                    >
                      {step.actionLabel}
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* RETURN NAVIGATION */}
          <div className="mt-5 pt-4 border-top d-flex justify-content-between">
            <button 
              type="button"
              className="btn btn-link text-decoration-none p-0 text-secondary small" 
              onClick={() => navigate("/registered/site-admin")}
            >
              <i className="bi bi-arrow-left me-2"></i>
              Return to Admin Dashboard
            </button>
            
            <span className="text-muted small align-self-center">
              Workflow State: <strong>Ready for Ingestion</strong>
            </span>
          </div>
        </section>

      </div>
    </div>
  );
}